<ng-container *transloco="let t">
  @if (isLoading) {
    <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <div class="user-details__header-wrapper">
    <h2 class="user-details__header">{{ t('user-details.details') }}</h2>
    <div class="user-details__actions">
      <div class="user-details__reload-button">
        <xi-icon-button icon="refresh" (onClick)="onReloadUser()"></xi-icon-button>
      </div>

      @if (isAdmin) {
        <xi-icon-button
          icon="trash"
          [disabled]="isCurrentUserSelected"
          [tooltip]="{ text: deleteUserTooltip, direction: 5 }"
          (onClick)="onDeleteUser()"
        ></xi-icon-button>
      }
    </div>
  </div>

  <div class="user-details__container">
    <div class="user-details__form-wrapper">
      <div class="user-details__form">
        <div class="user-details__form-label">{{ t('user-details.id') }}:</div>

        <div class="user-details__form-input">
          <div class="user-details__form-input-user-id">
            <span>{{ user.user_id }}</span>

            <xi-icon-button
              icon="copy"
              [tooltip]="{ text: t('user-details.copy-to-clipboard') }"
              (click)="copyUserId()"
              color="CX"
            ></xi-icon-button>
          </div>
        </div>

        <div class="user-details__form-label">{{ t('user-details.given-name') }}:</div>

        @if (isAdmin) {
          <app-inline-edit
            [control]="firstName"
            (update)="onFirstNameUpdate()"
            class="user-details__form-input"
          >
            <ng-template appViewMode>
              <div class="user-details__form-input--view">
                {{ user.first_name }}
              </div>
            </ng-template>
            <ng-template appEditMode>
              <mat-form-field class="user-details__form-input--edit">
                <input matInput appAutoFocus="100" [formControl]="firstName" />
              </mat-form-field>
            </ng-template>
          </app-inline-edit>
        } @else {
          <mat-form-field class="full-width">
            <input matInput [value]="user.first_name || ''" readonly />
          </mat-form-field>
        }

        <div class="user-details__form-label">{{ t('user-details.family-name') }}:</div>

        @if (isAdmin) {
          <app-inline-edit
            appEditOnEnter
            [control]="groupName"
            (update)="onLastNameUpdate()"
            class="user-details__form-input"
          >
            <ng-template appViewMode>
              <div class="user-details__form-input--view">
                {{ user.last_name }}
              </div>
            </ng-template>
            <ng-template appEditMode>
              <mat-form-field class="user-details__form-input--edit">
                <input matInput appAutoFocus="100" [formControl]="lastName" />
              </mat-form-field>
            </ng-template>
          </app-inline-edit>
        } @else {
          <mat-form-field class="full-width">
            <input matInput [value]="user.last_name || ''" readonly />
          </mat-form-field>
        }

        <div class="user-details__form-label">{{ t('user-details.email') }}:</div>

        @if (isAdmin) {
          <app-inline-edit
            appEditOnEnter
            [control]="email"
            (update)="onEmailUpdate()"
            class="user-details__form-input"
          >
            <ng-template appViewMode>
              <div class="user-details__form-input--view">
                {{ user.email }}
              </div>
            </ng-template>
            <ng-template appEditMode>
              <mat-form-field class="user-details__form-input--edit">
                <input matInput appAutoFocus="100" [formControl]="email" [disabled]="isLoading" />
                @if (email.invalid) {
                  <mat-error>{{ t('user-details.invalid-email') }}</mat-error>
                }
              </mat-form-field>
            </ng-template>
          </app-inline-edit>
        } @else {
          <mat-form-field class="full-width">
            <input matInput [value]="user.email" readonly />
          </mat-form-field>
        }

        <div class="user-details__form-label">{{ t('user-details.alternate-email') }}:</div>

        @if (isAdmin) {
          <app-inline-edit
            appEditOnEnter
            [control]="alternateEmail"
            (update)="onAlternateEmailUpdate()"
            class="user-details__form-input"
          >
            <ng-template appViewMode>
              <div class="user-details__form-input--view">
                {{ user.alternate_email }}
              </div>
            </ng-template>
            <ng-template appEditMode>
              <mat-form-field class="user-details__form-input--edit">
                <input
                  matInput
                  appAutoFocus="100"
                  [formControl]="alternateEmail"
                  [disabled]="isLoading"
                />
                @if (alternateEmail.invalid) {
                  <mat-error>{{ t('user-details.invalid-email') }}</mat-error>
                }
              </mat-form-field>
            </ng-template>
          </app-inline-edit>
        } @else {
          <mat-form-field class="full-width">
            <input matInput [value]="user.alternate_email" readonly />
          </mat-form-field>
        }

        <div class="user-details__form-label">{{ t('user-details.login') }}:</div>

        @if (isAdmin) {
          <app-inline-edit
            appEditOnEnter
            [control]="login"
            (update)="onLoginUpdate()"
            class="user-details__form-input"
          >
            <ng-template appViewMode>
              <div class="user-details__form-input--view">
                {{ user.login }}
              </div>
            </ng-template>
            <ng-template appEditMode>
              <mat-form-field class="user-details__form-input--edit">
                <input matInput appAutoFocus="100" [formControl]="login" [disabled]="isLoading" />
                @if (login.invalid) {
                  <mat-error>{{ t('user-details.invalid-login') }}</mat-error>
                }
              </mat-form-field>
            </ng-template>
          </app-inline-edit>
        } @else {
          <mat-form-field class="full-width">
            <input matInput [value]="user.login" readonly />
          </mat-form-field>
        }
        @if (isAdmin) {
          <div class="user-details__form-label">{{ t('user-details.last-login') }}:</div>
          <div class="user-details__form-input--view">
            {{ user.last_login | lexDate: 'long' }}
          </div>
        }
        @if (isAdmin) {
          <div class="user-details__form-label user-details__reset-password">
            {{ t('user-details.password') }}
          </div>
          <div class="user-details__reset-password">
            <xi-default-button
              text="{{ t('user-details.reset-password') }}"
              color="orca"
              (onClick)="onOpenChangePassword()"
            ></xi-default-button>
          </div>
        }
      </div>
    </div>

    @if (isAdmin) {
      <div class="user-details__list-wrapper">
        <app-user-permission-table
          [parent]="user"
          [userMemberships]="userMemberships"
          [remainingItems]="remainingGroups"
          [tableData]="userGroups"
          scrollbarHeight="30vh"
          [isLoading]="isLoading"
          (addItem)="onAddGroup()"
          (itemRemoved)="onGroupRemoved($event)"
          (permissionChanged)="onPermissionChanged()"
        >
        </app-user-permission-table>
      </div>
    }
  </div>

  <!--Change Password Modal-->
  @if (showPasswordModal) {
    <app-lex-xi-modal
      [isVisible]="showPasswordModal"
      [canBackdropClose]="false"
      (close)="onPasswordModalClosed()"
    >
      <ng-template appXIModalContent>
        @if (showPasswordModal) {
          <app-account-password
            [user]="user"
            (modalClosed)="onPasswordModalClosed()"
          ></app-account-password>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
</ng-container>
